export default __webpack_public_path__ + "static/media/Users_w.18d2ccc4.svg";